import { render, staticRenderFns } from "./LoadingBox.vue?vue&type=template&id=c1ae6346&"
import script from "./LoadingBox.vue?vue&type=script&lang=js&"
export * from "./LoadingBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports